// extracted by mini-css-extract-plugin
module.exports = {"container":"DE-z","recos":"EE-z","productCardOverride":"FE-z"};